var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.393 6.024l4.113-4.155c.292-.295.29-.77-.005-1.061-.294-.292-.77-.29-1.06.005L.803 5.496c-.289.292-.289.763 0 1.055l4.636 4.683c.292.294.767.297 1.06.005.295-.291.298-.766.006-1.06L2.393 6.024z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.337 6.796h17.48c.415 0 .75-.335.75-.75 0-.414-.335-.75-.75-.75H1.337c-.414 0-.75.336-.75.75 0 .415.336.75.75.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.53ea803c52dd35f7a3d6666832f13613.svg";
export { ForwardRef as ReactComponent };